import CloseIcon from '@mui/icons-material/Close';
import InfoIcon from '@mui/icons-material/Info';
import { Box, Button, Divider, IconButton, Modal, Typography } from "@mui/material";
import { useMemo, useState } from "react";
import "../CSS/Equipments.css";
import "../CSS/Layout.css";
import { labTools, nanoEquipments, uhvEquipments, userFacilities } from "../Configurations/Equipment";

export default function EquipmentPage() {
  const [openDetailedPicture, setOpenDetailedPicture] = useState(false);
  const [pictureDetail, setPictureDetail] = useState();

  function generateSmallImage(imageList, imgCssClass) {
    const images = [];
    for (var j = 0; j < imageList.length; j++) {
      images.push(
        <Box key={j} className={`image-wrapper ${imgCssClass}`}>
          <Box
            className={`hover-image ${imgCssClass}`}
            component="img"
            rel="noreferrer"
            alt={imageList[j].name}
            src={imageList[j].image} />
          <Box
            className='parts-hover'
            sx={{ position: "absolute", right: "0rem", top: "0rem", left: "0rem", bottom: "0rem" }}
          >
            <Box display="flex" justifyContent="center" alignItems="center" height="100%">
              <Typography p="0.2rem">
                {imageList[j].name}
              </Typography>
            </Box>
          </Box>
          <Box sx={{ position: "absolute", right: "0rem", top: "0rem", zIndex: "2", padding: "5px" }}>
            <IconButton className='info-icon'
              sx={{ padding: "0px" }}
              value={imageList[j].manufactoryUrl}
              onClick={(e) => {
                window.open(e.currentTarget.value, '_blank').focus();
              }}
            >
              <img className='equipment-manufactory-logo'
                alt={imageList[j].manufactoryLogo}
                rel="noreferrer"
                src={imageList[j].manufactoryLogo}
              />
            </IconButton>
            <IconButton
              color='grey'
              sx={{ padding: "0px" }}
              className='info-icon'
              value={JSON.stringify(imageList[j])}
              onClick={(e) => {
                setOpenDetailedPicture(true);
                setPictureDetail(e.currentTarget.value)
              }}
            >
              <InfoIcon />
            </IconButton>
          </Box>
        </Box>);
    }
    return images;
  }

  const UhvSection = useMemo(() => {
    const equipments = [];
    for (var i = 0; i < uhvEquipments.length; i++) {
      let uhv = uhvEquipments[i];
      equipments.push(<Box key={i} className="uhv">
        <Box className="uhv-overall">
          <Box
            className="uhv-overall-img"
            component="img"
            rel="noreferrer"
            alt={uhv.title}
            src={uhv.overallImage}
          />
          <Box className="uhv-overall-title" >
            <Box display="flex" alignItems="center" justifyContent="center" height='100%'>
              <Typography color="white">{uhv.name}</Typography>
            </Box>
          </Box>
        </Box>
        {uhv.parts.length > 0 && <Divider orientation='vertical' sx={{ height: "auto" }} />}
        <Box className="parts">
          {generateSmallImage(uhv.parts, "uhv-parts-image")}
        </Box>
      </Box>);
    }
    return equipments;
  }, []);

  const PictureModelContent = useMemo(() => {
    if (!pictureDetail) {
      setOpenDetailedPicture(false);
      return <></>;
    }
    let detail = JSON.parse(pictureDetail);
    return <Box className="modal-content">
      <img alt={detail.name}
        className='modal-image'
        component="img"
        rel="noreferrer"
        src={detail.image}
      />
      <Box className="model-text">
        <Typography
          color="primary"
          fontWeight="bold"
          fontSize="2rem"
          mb="1rem"
        >
          {detail.name}
        </Typography>
        <Typography textAlign="justify" sx={{ wordWrap: "break-word" }}>{detail.description}</Typography>
        {detail.manufactoryUrl &&
          <Button
            color="primary"
            sx={{ alignSelf: "end", width: "fit-content", marginTop: "20px" }}
            value={detail.manufactoryUrl}
            onClick={(e) => { window.open(e.currentTarget.value, '_blank').focus() }}
            startIcon={
              <img rel="noreferrer" className='equipment-manufactory-logo'
                alt={detail.manufactoryUrl}
                src={detail.manufactoryLogo}
              />
            }
          >
            {"Read More on Manufactory Page >>"}
          </Button>
        }
      </Box >
    </Box>;
  }, [pictureDetail]);


  const NanoSection = useMemo(() => {
    return (<Box className="small-equipment-row">
      {generateSmallImage(nanoEquipments, "other-equipment-image")}
    </Box>);
  }, []);

  const LabToolsSection = useMemo(() => {
    return (<Box className="small-equipment-row">
      {generateSmallImage(labTools, "other-equipment-image")}
    </Box>);
  }, []);


  const Facilities = useMemo(() => {
    const logos = [];
    for (var i = 0; i < userFacilities.length; i++) {
      logos.push(
        <a href={userFacilities[i].link} target="_blank" key={i} rel="noreferrer">
          <Box className='facility-logo'
            component="img"
            rel="noreferrer"
            src={userFacilities[i].img}
          />
        </a>
      );
    }
    return <Box className="flex-row-left" gap="40px">
      {logos}
    </Box>
  }, []);

  return (<>
    <Typography variant='h3'>UHV Equipments</Typography>
    <Box className="flex-column-left" gap={"40px"}>
      {UhvSection}
    </Box>
    <Typography variant='h3'>Nanomaterial Equipment</Typography>
    {NanoSection}
    <Typography variant='h3'>Lab Tools</Typography>
    {LabToolsSection}
    <Typography variant='h3'>User Facilities</Typography>
    {Facilities}

    <Modal
      open={openDetailedPicture}
      onClose={() => setOpenDetailedPicture(false)}
    >
      <Box className="modal-container">
        <Box className="picture-modal">
          {PictureModelContent}
          <IconButton
            sx={{ position: "absolute", top: "0rem", right: "0rem" }}
            color="primary"
            onClick={() => setOpenDetailedPicture(false)}>
            <CloseIcon />
          </IconButton>
        </Box>
      </Box>
    </Modal>
  </>);
}